function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { ApolloLink } from '@apollo/client';
import { Headers } from '@sail/data';
import addContextHeaders from '../../addContextHeaders';
export default function createContextHeadersLink() {
    return new ApolloLink(function contextHeadersLink(operation, forward) {
        const v1Context = operation.variables.v1Context || {};
        operation.setContext((prevContext)=>{
            var _prevContext_headers;
            const headers = new Headers([
                ...Object.entries((_prevContext_headers = prevContext === null || prevContext === void 0 ? void 0 : prevContext.headers) !== null && _prevContext_headers !== void 0 ? _prevContext_headers : {})
            ]);
            addContextHeaders(headers, v1Context);
            return _object_spread_props(_object_spread({}, prevContext), {
                headers: headers.getFetchHeaders()
            });
        });
        return forward(operation);
    });
}

//# sourceMappingURL=createContextHeadersLink.js.map